import { Progress } from '@inflearn/ds-react';
import { isNil } from 'lodash-es';
import { useTranslation } from 'react-i18next';

import useClientAccountProfileQuery from '../../../../../queries/useClientAccountProfileQuery';
import useMediaQuery from '../../../../../styles/useMediaQuery';
import { CourseCardMetaInfo } from './CourseCardMetaInfo';
import { FeedbackButtons } from './FeedbackButtons';
import type { CourseCardData } from './courseCardDataTransformer';

type Props = {
  progress: number;
  completeCount: number;
  expireInformation: {
    label: string;
    isExpired: boolean;
  };
  hasCertificate: boolean;
  isArchived: boolean;
  isArchivable: boolean;
  isCancelable: boolean;
  course: CourseCardData['course'];
  voucherId: number;
  isReviewable: boolean;
  review: CourseCardData['review'];
};
export const OnlineCourseCardMetaInfo = ({
  progress,
  completeCount,
  expireInformation,
  hasCertificate,
  isArchived,
  isArchivable,
  isCancelable,
  course,
  voucherId,
  isReviewable,
  review,
}: Props) => {
  const { t } = useTranslation();
  const { data: profile } = useClientAccountProfileQuery();
  const { isMobile } = useMediaQuery();

  const { lectureCount } = course;

  return (
    <>
      <Progress
        aria-label={t('진도율')}
        value={progress}
        size={isMobile ? 'sm' : 'md'}
        color="infgreen"
      />

      <CourseCardMetaInfo
        hasCertificate={hasCertificate}
        completeCount={completeCount}
        lectureCount={lectureCount}
        expireInformation={expireInformation}
        progress={progress}
        course={course}
        isArchived={isArchived}
        isArchivable={isArchivable}
        isCancelable={isCancelable}
        voucherId={voucherId}
        isPartners={!isNil(profile?.marketingPartner)}
      />

      <FeedbackButtons
        isReviewable={isReviewable}
        review={review}
        voucherId={voucherId}
        course={course}
      />
    </>
  );
};
